// extracted by mini-css-extract-plugin
export default {"leftContainer":"SplitLayout_leftContainer__Z4WOm","rightContainer":"SplitLayout_rightContainer__--kML"};